// Wordmark only. There is no hosted logo asset for stpwin.dev, and a broken
// image reads worse than none; the login page uses a letter tile in the same
// place, matching the tile the requesting application already gets.
export const BRAND_INITIAL = "S";

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand ${compact ? "brand--compact" : ""}`}>
      <span>
        <strong>stpwin.dev</strong>
        {!compact && <small>Identity</small>}
      </span>
    </div>
  );
}
